var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSettingNotificationTeamsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.032,
    y1: 0.032,
    x2: 0.97,
    y2: 0.97,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#5961c3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3a41ac"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_161452",
    "data-name": "Group 161452",
    transform: "translate(-304 -123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_161023",
    "data-name": "Group 161023",
    transform: "translate(304 123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_140235",
    "data-name": "Rectangle 140235",
    fill: "#fff",
    stroke: "#dce1e9",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 33,
    rx: 6,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 32,
    height: 32,
    rx: 5.5,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "MS_teams",
    "data-name": "MS teams",
    transform: "translate(311.49 131.371)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2508",
    "data-name": "Path 2508",
    d: "M36.881,13.695v3.254a2.441,2.441,0,0,1-4.881,0V12.881h4.068A.813.813,0,0,1,36.881,13.695Zm-2.441-2.441a1.627,1.627,0,1,0-1.627-1.627A1.627,1.627,0,0,0,34.441,11.254Z",
    transform: "translate(-20.611 -6.78)",
    fill: "#5059c9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2509",
    "data-name": "Path 2509",
    d: "M23.135,11.915v4.474A4.068,4.068,0,0,1,18.8,20.448a4.16,4.16,0,0,1-3.8-4.2V11.1h7.322A.813.813,0,0,1,23.135,11.915ZM19.068,9.881a2.441,2.441,0,1,0-2.441-2.441A2.44,2.44,0,0,0,19.068,9.881Z",
    transform: "translate(-10.526 -5)",
    fill: "#7b83eb"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_237",
    "data-name": "Ellipse 237",
    cx: 2.542,
    cy: 2.288,
    rx: 2.542,
    ry: 2.288,
    transform: "translate(6.101 0.102)",
    fill: "#7b83eb"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2510",
    "data-name": "Path 2510",
    d: "M19.474,25.418V20H15v5.148a4.3,4.3,0,0,0,.384,1.767h2.593A1.5,1.5,0,0,0,19.474,25.418Z",
    transform: "translate(-10.526 -13.899)",
    opacity: 0.05
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2511",
    "data-name": "Path 2511",
    d: "M15,20v5.148a4.3,4.3,0,0,0,.225,1.36h2.708A1.269,1.269,0,0,0,19.2,25.239V20Z",
    transform: "translate(-10.526 -13.899)",
    opacity: 0.07
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2512",
    "data-name": "Path 2512",
    d: "M18.932,20H15v5.148a4.28,4.28,0,0,0,.111.953H17.89a1.041,1.041,0,0,0,1.041-1.041V20Z",
    transform: "translate(-10.526 -13.899)",
    opacity: 0.09
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2513",
    "data-name": "Path 2513",
    d: "M11.322,22.135H4.814A.813.813,0,0,1,4,21.322V14.814A.813.813,0,0,1,4.814,14h6.508a.813.813,0,0,1,.814.814v6.508A.813.813,0,0,1,11.322,22.135Z",
    transform: "translate(-4 -10.339)",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2514",
    "data-name": "Path 2514",
    d: "M13.241,19H9.932v.7h1.239v3.368H12V19.7h1.239Z",
    transform: "translate(-7.519 -13.305)",
    fill: "#fff"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettingNotificationTeamsIcon);
export default __webpack_public_path__ + "static/media/setting-notification-teams-icon.3d26a258eae28cdc1aae53977b2848bf.svg";
export { ForwardRef as ReactComponent };